export default [
  {
    icon: 'mdi-information',
    title: 'Detail Verval',
    event: 'onVerval',
    akses: true,
  },
  {
    icon: 'mdi-close',
    title: 'Batal Verval',
    event: 'onBatalVerval',
    akses: 'kelas-verval.batal-verval',
  },
];
